export default [
    {
        path: '/player',
        component: () => import('@/views/player/index.vue'),
        meta: {
            title: '球员列表',
        },
    },
    {
        path: '/player/details',
        component: () => import('@/views/player/details.vue'),
        meta: {
            title: '球员详情',
        },
    },
];
